import { CardMedia, Hidden, Link } from "@material-ui/core";
import classNames from "classnames";
import { useSelector } from "react-redux";

import icon from "../../../assets/icons/ayvensFavicon.svg";
import { selectUserData } from "../../appData.slice";
import { MobileMenuToggler } from "../MobileMenuToggler";

import styles from "./Navigation.module.scss";

const LoginItem = () => {
  const userData = useSelector(selectUserData);
  const { login, name, surname } = userData;

  return login && name && surname ? (
    <li className="LoginSection">
      <span
        className={classNames(
          styles.navigation_login,
          styles.navigation_login_active
        )}
        color="textSecondary"
      >
        {name} {surname} ({login})
      </span>
    </li>
  ) : null;
};

export const Navigation = (): JSX.Element => (
  <nav className={styles.wrapper}>
    <MobileMenuToggler />
    <Hidden smDown>
      <ul className={styles.navigation}>
        <li>
          <Link
            color="textSecondary"
            href="https://www.leaseplan.com/pl-pl/kontakt/"
          >
            Pomoc / FAQ
          </Link>
        </li>
        <LoginItem />
        <li>
          <CardMedia component="img" src={icon} className={styles.icon} />
          <Link
            className={styles.navigation_country}
            color="textSecondary"
            href="https://www.leaseplan.com/select-country-language/"
          >
            PL
          </Link>
        </li>
      </ul>
    </Hidden>
  </nav>
);
